const keycloakConfig = {
	realm: import.meta.env.VITE_KEYCLOAK_REALM || 'Contaduria',
	url: import.meta.env.VITE_KEYCLOAK_URL || 'https://dev.keycloak.cgmisiones.gob.ar/',
	clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'Bienes_Fiscales_local',
	'ssl-required': 'external',
	'public-client': true,
	'confidential-port': 0
};

export default keycloakConfig;
